import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTennisEditedDays, getTennisIntervals, getTennisWeekSummary } from '../../../selectors/autobooking';
import AutoBooking from '../index';
import { checkPermisson, getTennisCompetitions } from '../../../selectors/common';
import { PERMISSIONS } from '../../../constants';
import { aAddTennisInterval, aGetTennisAutoBooking, aSaveTennisChanges } from '../../../reducers';
import { aClearTennisChanges, aDeleteTennisInterval } from '../../../reducers/autobooking';

const mapToProps = (state) => ({
  competitions: getTennisCompetitions(state),
  weekSummary: getTennisWeekSummary(state),
  intervals: getTennisIntervals(state),
  editedDays: getTennisEditedDays(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getIntervals: (payload) => dispatch(aGetTennisAutoBooking(payload)),
  deleteInterval: (payload) => dispatch(aDeleteTennisInterval(payload)),
  addNewInterval: (payload) => dispatch(aAddTennisInterval(payload)),
  clearChanges: (payload) => dispatch(aClearTennisChanges(payload)),
  saveChanges: (payload) => dispatch(aSaveTennisChanges(payload)),
});

const TennisAutoBooking = (props) => {
  const navigate = useNavigate();

  useEffect(()=>{
    props.getIntervals();
    // eslint-disable-next-line
  }, []);

  return (
    <AutoBooking
      weekSummary={props.weekSummary}
      intervals={props.intervals}
      editedDays={props.editedDays}
      leagues={props.competitions}
      deleteInterval={props.deleteInterval}
      addNewInterval={props.addNewInterval}
      clearChanges={props.clearChanges}
      navigate={navigate}
      saveChanges={props.saveChanges}
      hasPermissionToUpdate={props.checkPermisson(
        PERMISSIONS.TENNIS_AUTOBOOKING_INTERVAL_UPDATE,
      )}
      isTennis
    />
  );
};

export default connect(mapToProps, actionsToProps)(TennisAutoBooking);
